<template>
	<div>
		<ValidationObserver ref="form">
			<b-row class="mb-2 gap-y-2">
				<b-col cols="12" xl="6">
					<h2 class="text-primary font-weight-bolder mb-2">{{ title }}</h2>

					<div class="pr-1" style="overflow: auto; max-height: 60vh">
						<b-form-group :label="`1. Fecha`" label-class="font-weight-bold text-secondary" label-size="lg">
							<validation-provider rules="required" v-slot="{ errors }">
								<flat-pickr
									v-model="uploadVideo.date"
									class="form-control bg-transparent"
									placeholder="Elige una fecha"
									:class="errors[0] ? 'error-input' : 'mb-05'"
								/>

								<span style="color: red">{{ errors[0] }}</span>
							</validation-provider>
						</b-form-group>
						<hr />

						<b-form-group
							:label="`2. Local`"
							label-class="font-weight-bold text-secondary"
							label-size="lg"
						></b-form-group>
						<b-form-group class="mt-1" v-if="selectedLocalSpecimen == 'specimen' && !data">
							<template #label>
								Calificacion
								<b-form-checkbox class="d-inline ml-05" switch v-model="ratingLocalActive" />
							</template>
							<div class="d-flex mb-1" v-if="ratingLocalActive">
								<b-row class="d-flex gap-x-2 w-full mb-1">
									<b-col cols="8" class="pl-3">
										<veeno
											pipsy
											:connect="[true, false]"
											:handles="[0]"
											:range="{ min: 0, max: 5 }"
											:step="0.25"
											v-model="ratingLocal"
										/>
									</b-col>
									<b-col class="text-center text-nowrap font-weight-bolder h4">
										{{ ratingLocal }} / 5
									</b-col>
								</b-row>
							</div>
						</b-form-group>

						<b-form-group
							label-for="reason"
							v-if="uploadVideo.category_id === 1 && selectedLocalSpecimen === 'specimen'"
							:class="{ 'mt-1': data }"
						>
							<template #label>
								<span style="font-size: 0.9rem">Seleccionar motivo (local)</span>
							</template>
							<validation-provider rules="required" v-slot="{ errors }">
								<v-select
									id="reason"
									v-model="uploadVideo.local_reason_id"
									:options="reasons"
									label="name"
									:reduce="(option) => option.id"
									:clearable="false"
									:class="errors[0] ? 'error-input' : ''"
									:placeholder="'Seleccionar motivo...'"
									appendToBody
									:calculatePosition="positionDropdown"
								/>
							</validation-provider>
						</b-form-group>

						<!--  -->
						<hr />
						<b-form-group v-if="topeInterno">
							<b-form-group
								label="3. Rival"
								label-class="font-weight-bold text-secondary"
								label-size="lg"
							></b-form-group>

							<b-form-group
								class="mt-1"
								v-if="selectedVisitSpecimen == 'specimen' && !specimen_to_update_id"
							>
								<template #label>
									Calificacion
									<b-form-checkbox class="d-inline ml-05" switch v-model="ratingRivalActive" />
								</template>
								<!--  -->
								<div class="d-flex mb-1" v-if="ratingRivalActive">
									<b-row class="d-flex gap-x-2 w-full mb-1">
										<b-col cols="8" class="pl-3">
											<veeno
												pipsy
												:connect="[true, false]"
												:handles="[0]"
												:range="{ min: 0, max: 5 }"
												:step="0.25"
												v-model="ratingRival"
											/>
										</b-col>
										<b-col class="text-center text-nowrap font-weight-bolder h4">
											{{ ratingRival }} / 5
										</b-col>
									</b-row>
								</div>
							</b-form-group>

							<b-form-group
								label-for="reason2"
								v-if="uploadVideo.category_id === 1 && selectedVisitSpecimen === 'specimen'"
								:class="{ 'mt-1': data }"
							>
								<template #label>
									<span style="font-size: 0.9rem">Seleccionar motivo (rival)</span>
								</template>
								<validation-provider rules="required" v-slot="{ errors }">
									<v-select
										id="reason2"
										v-model="uploadVideo.rival_reason_id"
										@input="M_SET_INPUT({ data: $event, input: 'rival_reason_id' })"
										:options="reasons"
										label="name"
										:reduce="(option) => option.id"
										:clearable="false"
										:class="errors[0] ? 'error-input' : ''"
										:placeholder="'Seleccionar motivo...'"
										appendToBody
										:calculatePosition="positionDropdown"
									/>
								</validation-provider>
							</b-form-group>
						</b-form-group>
						<b-form-group
							v-if="topeExterno && draft"
							label="3. Rival"
							label-class="font-weight-bold text-secondary"
							label-size="lg"
						>
							{{ draft.rival ? draft.rival.name : "Rival" }}
						</b-form-group>
					</div>
				</b-col>
				<b-col cols="12" xl="6" class="d-flex flex-column">
					<h2 class="text-right text-primary mb-2">
						<b-button class="btn-icon" variant="outline-primary" @click="$emit('close')">
							<feather-icon icon="XIcon" />
						</b-button>
					</h2>
					<div class="grid-video" style="flex: 1">
						<div
							v-if="!uploadVideo.uid"
							class="container-video"
							style="height: 100%"
							@click="fileChange"
							:class="[errorVideo ? 'container-video-error' : '']"
						>
							<img
								class="image-mov"
								v-if="file && ['mp4', 'avi', 'mkv', 'flv', 'mov', 'MOV'].includes(file.extension)"
								src="https://cliply.co/wp-content/uploads/2019/07/371907120_YOUTUBE_ICON_TRANSPARENT_400.gif"
								alt=""
							/>
							<video class="" v-else :src="file ? file.base : null" autoplay muted></video>
							<div class="skeletor-video-content">
								<div class="d-flex flex-column gap-y-1 align-items-center" v-if="file.name">
									<span class="h6 p-1 rounded bg-white text-primary">
										Seleccionado: {{ file.name }}
									</span>
									<b-button class="font-weight-bolder" variant="outline-primary">
										Cambiar archivo
									</b-button>
								</div>
								<div class="d-flex flex-column gap-y-1 align-items-center" v-else>
									<feather-icon class="text-primary mb-1" icon="UploadIcon" size="80" />
									<span class="h2 text-primary">Subir Video</span>
									<b-button class="font-weight-bolder" variant="outline-primary">
										Elegir archivo
									</b-button>
								</div>
							</div>
							<input
								ref="fileInput"
								type="file"
								@input="fileChange"
								class="d-none"
								accept=".mp4,.avi,.mkv,.flv,.mov,.MOV"
							/>
							<p v-if="errorVideo" style="color: red">El video debe ser obligatorio</p>
						</div>

						<div v-else class="mt-1 w-100 content-video" style="position: relative; height: 100%">
							<iframe
								:src="`https://iframe.videodelivery.net/${uploadVideo.uid}?autoplay=true`"
								autoplay
								style="border: none; position: absolute; top: 0; height: 100%; width: 100%"
								allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture;"
								allowfullscreen="true"
								id="stream-player"
							></iframe>

							<div class="icon-delete-video">
								<feather-icon
									@click="
										M_SET_INPUT({ data: uploadVideo.uid, input: 'oldUid' })
										M_SET_INPUT({ data: null, input: 'uid' })
										M_SET_INPUT({ data: null, input: 'thumbnail' })
									"
									icon="TrashIcon"
									size="14"
									color="red"
								/>
							</div>
						</div>
					</div>
				</b-col>
			</b-row>
		</ValidationObserver>
		<div class="d-flex justify-content-end">
			<b-button
				:disabled="uploading || disabledBtn"
				variant="outline-primary"
				class="mb-1 mb-sm-0 mr-0 mr-sm-1"
				:block="$store.getters['app/currentBreakPoint'] === 'xs'"
				@click="saveVideo"
			>
				{{ data ? "Actualizar" : "Subir" }}
			</b-button>
		</div>
	</div>
</template>

<script>
import { mapState, mapActions, mapMutations, mapGetters } from "vuex"
import vSelect from "vue-select"
import { mask } from "vue-the-mask"
import Ripple from "vue-ripple-directive"
import veeno from "veeno"
import "nouislider/distribute/nouislider.min.css"
import { SPECIMEN_STATUS_ID } from "@/constants/specimen-statuses.js"
import { TOPE_REASON_ID } from "@/constants/tope-reasons.js"
import { TRAINING_STATUS_ID } from "@/constants/training_statuses.js"
export default {
	name: "UploadTopeVideo",
	directives: { mask, Ripple },
	components: {
		vSelect,
		veeno,
	},
	props: {
		reset: {
			default: false,
		},
		specimen_to_update_id: {
			type: Number,
			default: 0,
		},
		data: {
			type: Object,
			default: null,
		},
		title: {
			type: String,
			default: "Agregar Video",
		},
		draft: {
			type: Object,
			default: null,
		},
		reasons: {
			type: Array,
			default: () => [],
		},
	},
	async mounted() {
		if (this.draft) {
			const { local, rival, type_id } = this.draft
			this.M_SET_INPUT({ data: local.id, input: "specimen_id" })
			if (local.status_id === SPECIMEN_STATUS_ID.EN_CUIDO) {
				this.M_SET_INPUT({ data: TOPE_REASON_ID.CONTROL, input: "local_reason_id" })
			}

			if (local.status_id === SPECIMEN_STATUS_ID.PREPARACION) {
				this.M_SET_INPUT({ data: TOPE_REASON_ID.PREPARACION, input: "local_reason_id" })
			}

			if (local.training_status_id === TRAINING_STATUS_ID.TRIP) {
				this.M_SET_INPUT({ data: TOPE_REASON_ID.POST_VIAJE, input: "local_reason_id" })
			}
			if (type_id == 1) {
				this.M_SET_INPUT({ data: rival.id, input: "specimen_two_id" })
				if (rival.status_id === SPECIMEN_STATUS_ID.EN_CUIDO) {
					this.M_SET_INPUT({ data: TOPE_REASON_ID.CONTROL, input: "rival_reason_id" })
				}

				if (rival.status_id === SPECIMEN_STATUS_ID.PREPARACION) {
					this.M_SET_INPUT({ data: TOPE_REASON_ID.PREPARACION, input: "rival_reason_id" })
				}

				if (rival.training_status_id === TRAINING_STATUS_ID.TRIP) {
					this.M_SET_INPUT({ data: TOPE_REASON_ID.POST_VIAJE, input: "rival_reason_id" })
				}
			} else if (type_id == 2) {
				this.M_SET_INPUT({ data: rival.id, input: "rival_id" })
			}
			this.M_SET_INPUT({ data: this.draft.created_at, input: "date" })
			this.M_SET_INPUT({ data: type_id, input: "type_id" })
		}
		this.M_SET_INPUT({
			data: this.currentUser.user_id,
			input: "user_id",
		})
	},
	destroyed() {
		this.M_RESET_FORM_VIDEO({ category_idIn: 1, type_idIn: 1 })
	},
	computed: {
		...mapState("header_book", ["urlBackendNode", "id_specimen"]),
		...mapState("video", [
			"optionsType",
			"optionsResultado",
			"optionsSpecimen",
			"optionsRival",
			"optionsParticipant",
			"arrayAmarradores",
			"arrayCareadores",
			"dataFile",
			"uploadVideo",
			"arrayGallos",
			"optionsSpecimenRival",
			"file",
			"arrayTournaments",
			"arrayFightResults",
			"uploading",
		]),
		...mapGetters("video", ["optionsCategory"]),
		showOptionsCategory() {
			let is_specimen = true
			return this.optionsCategory(is_specimen)
		},
		layout() {
			return this.$store.getters["appConfig/layout"]
		},
		isPrestado() {
			return this.specimenObject.origin == 5
		},
		topeInterno() {
			return this.uploadVideo.category_id == 1 && this.uploadVideo.type_id == 1
		},
		topeExterno() {
			return this.uploadVideo.category_id == 1 && this.uploadVideo.type_id == 2
		},
		showSpecimenOptions() {
			if (this.uploadVideo.category_id == 2) {
				// SI ES TORNEO
				return this.specimenOptions.filter((s) => s.value == "specimen")
			}
			return this.specimenOptions
		},
	},
	data() {
		return {
			errorVideo: false,
			videoNoRequired: true,
			barraLoader: 0,
			selectedLocalSpecimen: "specimen",
			selectedVisitSpecimen: "specimen",
			specimenOptions: [
				{ value: "specimen", text: "Ejemplar" },
				{ value: "chick", text: "Pollo" },
			],
			optionsVisitSpecimens: [
				{ value: "specimen", text: "Ejemplar" },
				{ value: "chick", text: "Pollo" },
			],
			has_rivals: false,
			ratingLocal: 0,
			ratingLocalActive: false,
			qualityLocal: null,
			defectLocal: null,
			ratingRival: 0,
			ratingRivalActive: false,
			qualityRival: null,
			defectRival: null,
			disabledBtn: false,
			local_status_id: null,
			rival_status_id: null,
		}
	},
	methods: {
		...mapMutations("video", [
			"M_SET_INPUT",
			"M_RESET_FORM_VIDEO",
			"M_DATA_FILE",
			"M_SET_TOURNAMENT_SPECIMEN_ARRAY",
			"M_SET_VIDEO_BY_ID",
			"M_SET_SPECIMENS",
			"M_SET_SPECIMENS_RIVAL",
		]),
		...mapActions("video", [
			"A_GET_RIVALS",
			"A_GET_ARRAY_AMARRADOR",
			"A_GET_ARRAY_CAREADOR",
			"A_SEARCH_EJEMPLAR",
			"A_DATE_RESULT_NOW",
			"A_SAVE_VIDEO",
			"A_UPLOAD_VIDEO_NODE",
			"A_SAVE_VIDEO_TOURNAMENT",
			"A_GET_PLATE_SPECIMEN_BY_ID",
			"A_UPDATE_VIDEO_TOPES",
			"A_UPDATE_VIDEO_TOURNAMENT",
			"A_GET_SPECIMENS_RIVAL",
			"A_GET_CORR_CHICK_BY_ID",
			"A_GET_TOURNAMENTS",
			"A_GET_FIGHT_RESULTS_BY_TOURNAMENT_ID",
		]),
		...mapActions({
			A_GET_DAYS_WITHOUT_TOPES_COUNTER: "commons/A_GET_DAYS_WITHOUT_TOPES_COUNTER",
		}),
		fileChange() {
			this.$refs.fileInput.click()
			let input = this.$refs.fileInput
			let file = input.files
			const typeOfFile = file[0] && file[0].name.split(".")[file[0].name.split(".").length - 1]
			this.setVideo(file, "video")
		},
		setVideo(file, type) {
			const typeOfFile = file[0] && file[0].name.split(".")[file[0].name.split(".").length - 1]
			this.errorVideo = false
			if (file && file[0]) {
				this.M_DATA_FILE({
					name: file[0].name,
					data: file[0],
					type,
					base: null,
					progress: 0,
					uploadFinished: false,
					extension: typeOfFile,
				})
			}
		},
		async saveVideo() {
			const validForm = await this.$refs.form.validate()
			if (!validForm) return
			this.M_SET_INPUT({ data: this.currentUser.user_id, input: "user_id" })
			if (this.file.data) {
				this.errorVideo = false
			} else {
				this.errorVideo = true
			}
			if (validForm && !this.errorVideo) {
				const videoForm = new FormData()
				videoForm.set("local_reason_id", this.uploadVideo.local_reason_id)
				videoForm.set("rival_reason_id", this.uploadVideo.rival_reason_id)
				for (const [keys, values] of Object.entries(this.uploadVideo)) {
					if (values !== null) {
						videoForm.append(`${keys}`, values)
					}
				}
				if (this.ratingLocalActive) {
					videoForm.append("rating_local", this.ratingLocal)
					videoForm.set("qualities", this.qualityLocal)
					videoForm.set("defects", this.defectLocal)
				}
				if (this.ratingRivalActive) {
					videoForm.append("rating_rival", this.ratingRival)
					videoForm.set("qualities_rival", this.qualityRival)
					videoForm.set("defects_rival", this.defectRival)
				}
				if (this.draft) {
					videoForm.append("draft_id", this.draft.id)
				}
				if (this.uploadVideo.oldUid || this.file.data) {
					this.disabledBtn = true
					const toSend = {
						fileData: this.file.data,
						videoForm,
						id: this.draft.id,
					}
					this.$emit("uploadVideo", toSend)
				}
				this.showToast(
					"success",
					"top-right",
					"Video",
					"CheckIcon",
					"El video se ha guardado correctamente, se está procesando su información."
				)
				this.$emit("resetTable")
				this.disabledBtn = false
			} else {
				this.errorVideo = true
			}
		},
		positionDropdown(dropdownList, component, { width, top, left }) {
			dropdownList.style.zIndex = 9999
			dropdownList.style.maxHeight = "12rem"
			dropdownList.style.top = top
			dropdownList.style.left = left
			dropdownList.style.width = width
		},
	},
}
</script>

<style lang="scss" scoped>
.container-video {
	height: 186px;
	width: 100%;
	box-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);

	// background: red;
	video {
		// background: gold;
		width: 100%;
		height: 100%;
		object-fit: cover;
		object-position: center;
		border-radius: 4px;
		padding: 4px;
		// background: red;
	}

	position: relative;
	cursor: pointer;

	.skeletor-video-content {
		border-radius: 0.5rem;
		border: 2px dashed var(--primary);
		padding: 4px;
		// background: rgba(30, 30, 30, 0.5);
		background: #8095ff54;
		position: absolute;
		top: 4px;
		left: 4px;
		right: 4px;
		bottom: 4px;
		display: flex;
		align-items: center;
		justify-content: center;

		p {
			color: var(--primary);
			margin-bottom: 0;
			font-size: 20px;
			font-weight: bolder;
		}
	}
}

.container-form12 {
	display: grid;
	grid-template-columns: 1fr;
	grid-template-rows: 1fr 2fr;

	gap: 1rem;

	position: relative;

	@media screen and (min-width: 1000px) {
		gap: 1rem;
		grid-template-areas: 1fr 1fr 1fr;
		grid-template-columns: 1fr 1fr;
	}

	@media screen and (min-width: 1400px) {
		gap: 2rem;
		grid-template-areas: 1fr 1fr 1fr;
		grid-template-columns: 1fr 1fr 1fr;
	}

	.grid-video {
		@media screen and (min-width: 600px) {
			grid-row: span 3 / span 3;
		}
	}

	.grid-description {
		@media screen and (min-width: 900px) {
			grid-column: span 2 / span 2;
			grid-column-start: 3;
		}
	}

	.skeletor-form-disabled {
		position: absolute;
		width: 100%;
		height: 100%;
		background: transparent;
		z-index: 100;
	}
}

.pro {
	grid-column: span 4 / span 4;
	background: red;
	margin-bottom: 2rem;
	border-radius: 10px;
	overflow: hidden;

	.container-pro {
		background: burlywood;
		position: relative;
		width: 100%;
		height: 20px;

		.bar {
			transition: 0.5s all ease-in-out;
			width: 0%;
			position: absolute;
			top: 0;
			left: 0;
			bottom: 0;
			background: var(--primary);
			display: flex;
			align-items: center;
			justify-content: center;

			p {
				color: #fff;
				margin: 0;
			}
		}
	}
}

.image-mov {
	width: 100% !important;
	height: 100% !important;
	object-fit: contain !important;
	object-position: center;
}

.container-video-error {
	border: 2px solid red;
	border-radius: 6px;
}

.error-input {
	border: 1.2px solid red;
	border-radius: 6px;
}

.circle-container {
	display: flex;
	align-items: center;
	margin-top: 1rem;

	.circle-item {
		margin-right: 1rem;
		display: flex;
		align-items: center;

		cursor: pointer;

		.circle {
			height: 16px;
			width: 16px;
			border-radius: 50%;
			border: 2px solid var(--primary);
			transition: 0.3s all ease-in-out;
			margin-right: 0.3rem;
			background: #fff;
			margin-top: 0 !important;
		}

		p {
			font-size: 12px;

			@media screen and (min-width: 900px) {
				font-size: 14px;
			}
		}

		.active {
			background: var(--primary);
			padding: 0.2rem;
		}
	}
}

.container-select-rival-torneo {
	display: flex;
	align-items: flex-start;

	.container-text {
		display: flex;
		flex-direction: column;

		span {
			font-weight: bold;
		}
	}
}

.circle {
	height: 10px;
	width: 10px;
	background: var(--primary);
	border-radius: 50%;
	margin-right: 0.25rem;
	margin-top: 0.5rem;
}

.circle1 {
	background: #7fe132;
}

.circle2 {
	background: #f50d0d;
}

.circle3 {
	background: #efefef;
}

.container-total-form {
	display: grid;
	grid-template-columns: 1fr;
	gap: 1rem;

	@media screen and (min-width: 1000px) {
		gap: 2rem;
		grid-template-columns: 1fr 1fr;
	}

	@media screen and (min-width: 1300px) {
		gap: 2rem;
		grid-template-columns: 3fr 1fr;
	}
}

.grid-col-2 {
	grid-column: span 2 / span 2;
}

.barra {
	// background: #f50d0d;
	border-radius: 8px;
	position: relative;
	box-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
	height: 24px;
	margin-bottom: 2rem;
	overflow: hidden;

	.back {
		position: absolute;
		top: 0;
		left: 0;
		bottom: 0;
		right: 0;
		height: 100%;
		// width: 40%;
		background: var(--primary);
		color: white;
		display: flex;
		align-items: center;
		justify-content: center;
		font-weight: bold;
		transition: 0.3 all ease-in-out;
	}
}

.disabled {
	background: #dddddd !important;
	border-color: #dddddd !important;
}

.icon-delete-video {
	position: absolute;
	top: 0;
	right: 0;
}
</style>

<style>
[dir] .noUi-connect {
	background: var(--primary);
}
</style>
